(function () {
  var MAKE_ALIASES = {
    honda: 'Honda',
    toyota: 'Toyota',
    lexus: 'Lexus',
    infiniti: 'Infiniti',
    mitsubishi: 'Mitsubishi',
    ford: 'Ford',
    bmw: 'BMW',
    subaru: 'Subaru',
    scion: 'Scion'
  };

  var MODEL_RULES = [
    { make: 'honda', model: 'Accord', test: /accord/ },
    { make: 'honda', model: 'Civic', test: /civic/ },
    { make: 'honda', model: 'CR-V', test: /cr-?v/ },
    { make: 'toyota', model: 'Camry', test: /camry/ },
    { make: 'toyota', model: 'Avalon', test: /avalon/ },
    { make: 'toyota', model: '86', test: /\b86\b|gt86/ },
    { make: 'lexus', model: 'RC350', test: /rc\s?350|rc350/ },
    { make: 'lexus', model: 'ES350', test: /es\s?350|es350/ },
    { make: 'infiniti', model: 'Q50', test: /q50/ },
    { make: 'infiniti', model: 'G35', test: /g35/ },
    { make: 'infiniti', model: 'G37', test: /g37/ },
    { make: 'mitsubishi', model: 'Lancer EVO X', test: /evo\s?x|evolution\s?x/ },
    { make: 'mitsubishi', model: 'Lancer EVO VIII/IX', test: /evo\s?(8|9|viii|ix)|evolution\s?(viii|ix)/ },
    { make: 'ford', model: 'Focus', test: /focus/ },
    { make: 'ford', model: 'Mustang', test: /mustang/ },
    { make: 'bmw', model: 'G20/G21/G28', test: /\bg20\b|\bg21\b|\bg28\b/ },
    { make: 'subaru', model: 'BRZ', test: /\bbrz\b/ },
    { make: 'scion', model: 'FR-S', test: /fr-?s/ }
  ];

  function normalize(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseYearRanges(text) {
    var ranges = [];
    var rangeRe = /(20\d{2})\s*[-/]\s*(20\d{2}|\d{2})/g;
    var m;
    while ((m = rangeRe.exec(text))) {
      var start = parseInt(m[1], 10);
      var endRaw = m[2];
      var end = endRaw.length === 2 ? 2000 + parseInt(endRaw, 10) : parseInt(endRaw, 10);
      if (end < start) end = start;
      ranges.push([start, end]);
    }
    var plusRe = /(20\d{2})\+/g;
    while ((m = plusRe.exec(text))) {
      ranges.push([parseInt(m[1], 10), 2027]);
    }
    if (!ranges.length) {
      var single = text.match(/\b(20\d{2})\b/);
      if (single) {
        var y = parseInt(single[1], 10);
        ranges.push([y, y]);
      }
    }
    return ranges;
  }

  function yearInRanges(year, ranges) {
    if (!ranges.length) return false;
    return ranges.some(function (r) {
      return year >= r[0] && year <= r[1];
    });
  }

  function fitmentsForProduct(product) {
    var text = normalize(product.title + ' ' + (product.tags || []).join(' '));
    var ranges = parseYearRanges(text);
    var fits = [];

    MODEL_RULES.forEach(function (rule) {
      if (!rule.test.test(text)) return;
      // Prefer explicit make mention, but allow model-only matches for known chassis
      var makeMentioned = text.indexOf(rule.make) !== -1 || rule.make === 'bmw' || rule.make === 'scion';
      if (!makeMentioned && rule.make !== 'toyota' && rule.make !== 'subaru') return;
      fits.push({
        make: MAKE_ALIASES[rule.make],
        makeKey: rule.make,
        model: rule.model,
        ranges: ranges.length ? ranges : [[2010, 2027]]
      });
    });

    // Dual-fit special case already covered by multiple MODEL_RULES hits
    return fits;
  }

  function buildCatalog(products) {
    var catalog = [];
    products.forEach(function (product) {
      if (!product || !product.title) return;
      var skip = /hoodie|shipping|replacement screws/i.test(product.title);
      if (skip) return;
      var fits = fitmentsForProduct(product);
      if (!fits.length) return;
      catalog.push({
        title: product.title,
        url: product.url,
        image: product.image,
        price: product.price,
        available: product.available !== false,
        fits: fits
      });
    });
    return catalog;
  }

  function uniqueSorted(values) {
    return values
      .filter(function (v, i, arr) {
        return v && arr.indexOf(v) === i;
      })
      .sort(function (a, b) {
        return String(a).localeCompare(String(b));
      });
  }

  function fillSelect(select, values, placeholder) {
    select.innerHTML = '';
    var opt0 = document.createElement('option');
    opt0.value = '';
    opt0.textContent = placeholder;
    select.appendChild(opt0);
    values.forEach(function (value) {
      var opt = document.createElement('option');
      opt.value = value;
      opt.textContent = value;
      select.appendChild(opt);
    });
    select.disabled = values.length === 0;
  }

  function money(price) {
    if (price == null || price === '') return '';
    if (typeof price === 'string' && price.indexOf('$') !== -1) return price;
    var n = Number(price);
    if (isNaN(n)) return '';
    // Shopify liquid money already formatted preferred; cents fallback
    if (n > 1000) n = n / 100;
    return '$' + n.toFixed(2);
  }

  function initFinder(root) {
    var dataEl = root.querySelector('[data-vehicle-finder-products]');
    if (!dataEl) return;

    var products = [];
    try {
      products = JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
      products = [];
    }

    var catalog = buildCatalog(products);
    var yearSelect = root.querySelector('[data-vf-year]');
    var makeSelect = root.querySelector('[data-vf-make]');
    var modelSelect = root.querySelector('[data-vf-model]');
    var form = root.querySelector('[data-vf-form]');
    var results = root.querySelector('[data-vf-results]');
    var empty = root.querySelector('[data-vf-empty]');
    var status = root.querySelector('[data-vf-status]');

    var years = [];
    for (var y = 2025; y >= 2003; y--) years.push(String(y));
    fillSelect(yearSelect, years, 'Year');
    fillSelect(makeSelect, [], 'Make');
    fillSelect(modelSelect, [], 'Model');
    makeSelect.disabled = true;
    modelSelect.disabled = true;

    function selectedYear() {
      return parseInt(yearSelect.value, 10);
    }

    function makesForYear(year) {
      var makes = [];
      catalog.forEach(function (item) {
        item.fits.forEach(function (fit) {
          if (yearInRanges(year, fit.ranges)) makes.push(fit.make);
        });
      });
      return uniqueSorted(makes);
    }

    function modelsForYearMake(year, make) {
      var models = [];
      catalog.forEach(function (item) {
        item.fits.forEach(function (fit) {
          if (fit.make === make && yearInRanges(year, fit.ranges)) models.push(fit.model);
        });
      });
      return uniqueSorted(models);
    }

    function matchingProducts(year, make, model) {
      return catalog.filter(function (item) {
        return item.fits.some(function (fit) {
          return fit.make === make && fit.model === model && yearInRanges(year, fit.ranges);
        });
      });
    }

    function productKey(item) {
      if (item.handle) return item.handle;
      if (!item.url) return '';
      var parts = String(item.url).split('/').filter(Boolean);
      return parts[parts.length - 1] || '';
    }

    function filterGrid(items) {
      var gridSelector = root.getAttribute('data-vf-grid') || '#collectionProductGrid';
      var grid = document.querySelector(gridSelector);
      if (!grid) return;

      var matchHandles = {};
      var matchUrls = {};
      items.forEach(function (item) {
        var key = productKey(item);
        if (key) matchHandles[key] = true;
        if (item.url) matchUrls[item.url] = true;
      });

      var cards = grid.querySelectorAll('[data-product-url], [data-product-handle]');
      var visible = 0;
      cards.forEach(function (card) {
        var handle = card.getAttribute('data-product-handle') || '';
        var url = card.getAttribute('data-product-url') || '';
        var match = !!(matchHandles[handle] || matchUrls[url]);
        card.classList.toggle('is-fitment-hidden', !match);
        var link = card.querySelector('.product-card');
        if (link) link.classList.toggle('is-fitment-match', match);
        if (match) visible += 1;
      });
      return visible;
    }

    function clearGridFilter() {
      var gridSelector = root.getAttribute('data-vf-grid') || '#collectionProductGrid';
      var grid = document.querySelector(gridSelector);
      if (!grid) return;
      grid.querySelectorAll('.is-fitment-hidden').forEach(function (el) {
        el.classList.remove('is-fitment-hidden');
      });
      grid.querySelectorAll('.is-fitment-match').forEach(function (el) {
        el.classList.remove('is-fitment-match');
      });
      grid.removeAttribute('data-fitment-empty');
      var fitmentEmpty = document.querySelector('[data-b1c-fitment-empty]');
      if (fitmentEmpty) fitmentEmpty.hidden = true;
      updateCollectionCount(null);
    }

    function updateGarageLink(year, make, model) {
      var garage = root.querySelector('[data-vf-garage]');
      if (!garage) return;
      if (!year || !make || !model) {
        garage.href = '/pages/garage';
        return;
      }
      garage.href =
        '/pages/garage?year=' +
        encodeURIComponent(year) +
        '&make=' +
        encodeURIComponent(make) +
        '&model=' +
        encodeURIComponent(model);
    }

    function renderResults(items, year, make, model) {
      if (!results) return;
      results.innerHTML = '';
      results.hidden = false;
      empty.hidden = true;
      if (!items.length) {
        empty.hidden = false;
        empty.textContent =
          'No parts found for ' + year + ' ' + make + ' ' + model + '. Try another year or contact us.';
        status.textContent = '';
        return;
      }
      status.textContent =
        items.length + (items.length === 1 ? ' part' : ' parts') + ' for your ' + year + ' ' + make + ' ' + model;
      items.forEach(function (item) {
        var a = document.createElement('a');
        a.className = 'vehicle-finder__result';
        a.href = item.url;
        a.innerHTML =
          '<span class="vehicle-finder__result-media">' +
          (item.image
            ? '<img src="' + item.image + '" alt="" loading="lazy" width="120" height="120">'
            : '') +
          '</span>' +
          '<span class="vehicle-finder__result-copy">' +
          '<span class="vehicle-finder__result-title">' +
          item.title +
          '</span>' +
          (item.price
            ? '<span class="vehicle-finder__result-price">' + money(item.price) + '</span>'
            : '') +
          '</span>';
        results.appendChild(a);
      });
    }

    function applySelection() {
      var year = selectedYear();
      var make = makeSelect.value;
      var model = modelSelect.value;
      var mode = root.getAttribute('data-vf-mode') || 'results';

      updateGarageLink(year, make, model);

      if (!year || !make || !model) {
        status.textContent = '';
        if (results) results.innerHTML = '';
        empty.hidden = true;
        clearGridFilter();
        return;
      }

      var items = matchingProducts(year, make, model);
      if (mode === 'filter') {
        var visible = filterGrid(items);
        var fitmentEmpty = document.querySelector('[data-b1c-fitment-empty]');
        var gridEl = document.querySelector(root.getAttribute('data-vf-grid') || '#collectionProductGrid');
        empty.hidden = true;
        if (!items.length || visible === 0) {
          status.textContent =
            'No parts in this collection for ' + year + ' ' + make + ' ' + model;
          if (!items.length) clearGridFilter();
          if (fitmentEmpty) fitmentEmpty.hidden = false;
          if (gridEl) gridEl.setAttribute('data-fitment-empty', 'true');
          updateCollectionCount(0);
        } else {
          status.textContent =
            visible +
            (visible === 1 ? ' part' : ' parts') +
            ' on this page for your ' +
            year +
            ' ' +
            make +
            ' ' +
            model;
          if (fitmentEmpty) fitmentEmpty.hidden = true;
          if (gridEl) gridEl.removeAttribute('data-fitment-empty');
          updateCollectionCount(visible);
        }
        return;
      }

      renderResults(items, year, make, model);
    }

    function updateCollectionCount(n) {
      var countEl = document.querySelector('[data-b1c-count]');
      if (!countEl) return;
      if (typeof n !== 'number') {
        countEl.textContent = countEl.getAttribute('data-b1c-count-default') || countEl.textContent;
        return;
      }
      if (!countEl.getAttribute('data-b1c-count-default')) {
        countEl.setAttribute('data-b1c-count-default', countEl.textContent.trim());
      }
      countEl.textContent = n + (n === 1 ? ' part' : ' parts');
    }

    yearSelect.addEventListener('change', function () {
      var year = selectedYear();
      fillSelect(modelSelect, [], 'Model');
      modelSelect.disabled = true;
      if (results) results.innerHTML = '';
      empty.hidden = true;
      status.textContent = '';
      clearGridFilter();
      updateGarageLink('', '', '');
      if (!year) {
        if (!presetMake) {
          fillSelect(makeSelect, [], 'Make');
          makeSelect.disabled = true;
        }
        return;
      }
      var makes = makesForYear(year);
      if (presetMake) {
        fillSelect(makeSelect, makes.indexOf(presetMake) !== -1 ? [presetMake] : makes, 'Make');
        makeSelect.value = presetMake;
        makeSelect.disabled = true;
        fillSelect(modelSelect, modelsForYearMake(year, presetMake), 'Model');
        modelSelect.disabled = false;
      } else {
        fillSelect(makeSelect, makes, 'Make');
        makeSelect.disabled = false;
      }
    });

    makeSelect.addEventListener('change', function () {
      var year = selectedYear();
      var make = makeSelect.value;
      if (results) results.innerHTML = '';
      empty.hidden = true;
      status.textContent = '';
      clearGridFilter();
      updateGarageLink(year, make, '');
      if (!year || !make) {
        fillSelect(modelSelect, [], 'Model');
        modelSelect.disabled = true;
        return;
      }
      fillSelect(modelSelect, modelsForYearMake(year, make), 'Model');
      modelSelect.disabled = false;
    });

    modelSelect.addEventListener('change', function () {
      applySelection();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var year = selectedYear();
      var make = makeSelect.value;
      var model = modelSelect.value;
      if (!year || !make || !model) {
        status.textContent = 'Select year, make, and model to find parts.';
        return;
      }
      applySelection();
    });

    var presetMake = root.getAttribute('data-vf-preset-make') || '';
    if (presetMake) {
      // Wait for first year pick; make stays locked to brand collection
      fillSelect(makeSelect, [presetMake], 'Make');
      makeSelect.value = presetMake;
      makeSelect.disabled = true;
    }
  }

  function boot() {
    document.querySelectorAll('[data-vehicle-finder]').forEach(initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
